// T2T-03-SG2 — Vendor field access API wrappers
import { getData, putData } from '../FetchApiServices';

// Returns { group_code: access_level } for a given action+role
export const getAccessMatrix   = (workflowAction, roleCode) =>
  getData(`t2t/vendor-field-access?workflow_action=${workflowAction}&role_code=${roleCode}`);

// Returns all rows for a workflow_action (admin matrix editor)
export const getMatrixForAction = (workflowAction) =>
  getData(`t2t/vendor-field-access/${workflowAction}`);

// Update a single cell
export const upsertAccessRule   = (body) => putData('t2t/vendor-field-access', body);
